// Firestore collection names — single authoritative representation (Standards.md §1.2).
// Keep in sync with firestore.rules match blocks when adding a collection.

export const COLLECTIONS = {
  EVENTS: 'events',
  GYMS: 'gyms',
  USERS: 'users',
  BOOKINGS: 'bookings',
  CAMP_BOOKINGS: 'campBookings',
  GYM_CLAIM_REQUESTS: 'gymClaimRequests',
  GYM_OUTREACH: 'gymOutreach',
  NOTIFICATIONS: 'notifications',
  DEDUPE_IGNORED: 'dedupeIgnored',
};
